var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIoIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.065 5.7L.857 14.058l9.208-8.356s0 0 0 0zm.103.109a3.087 3.087 0 014.363-4.364 3.087 3.087 0 01-4.363 4.364zm4.11 12.491l9.208-8.357-9.208 8.356s0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.175 18.191a3.087 3.087 0 01-4.364 4.364 3.087 3.087 0 014.364-4.364z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoIcon);
export default __webpack_public_path__ + "static/media/io-icon.80bc6f0f5eff50eecc822cc2a1f559f3.svg";
export { ForwardRef as ReactComponent };